<template>
  <!-- ok保提现验证 -->
  <div>
    <Modal v-model="visible" title="提示" class="phone-valid-box" class-name="vertical-center-modal" width="600">
      <Form v-if="visible" ref="myForm" :model="formData" :label-width="120" class="page-form">
        <div class="notice">打款前,请先上传发票,您要上传的发票对应的打款信息如下:</div>
        <FormItem v-if="tabId == 1" label="结算单名称名称:" class="full">
          <div v-html="formData.policyNo"></div>
        </FormItem>
        <FormItem v-else-if="tabId == 2" label="风险单名称:" class="full">
          <div v-html="formData.policyNo"></div>
        </FormItem>
        <FormItem label="打款金额:" class="full"> {{ formData.commissionPrice || 0 }}元 </FormItem>
        <FormItem label="发票信息:" class="full" prop="detail" :rules="$units.formRule.arrRequired('请上传发票信息', (trigger = 'change'))">
          <uploadNew v-model="formData.detail" fileType="img" :muti="true" :showFileName="true"></uploadNew>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button size="large" @click="visible = false">取消</Button>
        <Button type="primary" size="large" @click="ok">确定</Button>
      </div>
    </Modal>
    <!-- 单个打款 -->
    <okbao-check ref="okbaoCheck" @reload="success" />
  </div>
</template>
  
  <script>
import { common, codeTools } from '@/api/mixins';
import okbaoCheck from './okbaoCheck';
import uploadNew from '@/components/commons/uploadNew';
export default {
  mixins: [common, codeTools],
  components: { uploadNew, okbaoCheck },
  data() {
    return {
      visible: false,
      tabId: '',
      formData: {
        detail: []
      }
    };
  },
  computed: {},
  methods: {
    uploadChange(data) {
      this.$set(this.formData, 'detail', data);
    },
    success() {
      this.$emit('reload');
      this.visible = false;
    },
    ok() {
      this.$refs.myForm.validate(valid => {
        if (!valid) {
          return;
        }
        let data = JSON.parse(JSON.stringify(this.formData));
        delete data.policyNo;
        delete data.commissionPrice;
        this.$refs.okbaoCheck.open(data, this.tabId);
      });
    },
    open(data = [], tabId) {
      this.formData = { ...JSON.parse(JSON.stringify(data)), detail: [] };
      this.tabId = tabId;
      this.visible = true;
    }
  }
};
</script>
  
  <style lang="scss" scoped>
/deep/.ivu-modal-body {
  padding: 0;
}
.notice {
  padding: 10px 30px 10px 40px;
}
</style>
  